import { injectDataLayer } from '@wkda/data-layer';
import { GTM_ID_BY_LOCALES } from 'config';
import { LOCALE } from 'helpers/i18n';
import * as PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { useGTM } from '../../../modules/gtm';
import { getGdprBannerContent } from '../../page/Layout/selectors';

function DataLayerScript({ GDPRCookieBanner }) {
  const [GTMScript, setGTMScript] = useState(null);
  const gtmService = useGTM({
    onStart(script) {
      setGTMScript(script);
    },
  });

  useEffect(() => {
    if (!GDPRCookieBanner) {
      gtmService.startImmediately();
    } else {
      gtmService.init();
    }
  }, []);

  return (
    <Helmet>
      {GTMScript ? (
        <script>{injectDataLayer(GTM_ID_BY_LOCALES[LOCALE])}</script>
      ) : null}
    </Helmet>
  );
}

const PTContentSection = PropTypes.shape({
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}).isRequired;

DataLayerScript.propTypes = {
  GDPRCookieBanner: PropTypes.shape({
    title: PropTypes.string.isRequired,
    info: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    secondaryButton: PropTypes.shape({
      default: PropTypes.string.isRequired,
      selection: PropTypes.string.isRequired,
    }).isRequired,
    selectionInfo: PropTypes.string.isRequired,
    essential: PTContentSection,
    analytical: PTContentSection,
    marketing: PTContentSection,
  }),
};

const mapStateToProps = (state) => ({
  GDPRCookieBanner: getGdprBannerContent(state),
});

const ConnectedDataLayerScript = connect(mapStateToProps)(DataLayerScript);

export { ConnectedDataLayerScript as DataLayerScript };
